export default [
  {
    path:'/admin/seckill/list',
    name:'SeckillList',
    component:()=>import('../views/seckill/seckill_list'),
    meta:{
      title:'限时秒杀-活动列表'
    }
  },
  {
    path:'/admin/seckill/edit',
    name:'SeckillEdit',
    component:()=>import('../views/seckill/seckill_edit'),
    meta:{
      title:'限时秒杀-活动列表'
    }
  },
  {
    path:'/admin/seckill/settings',
    name:'SeckillSettings',
    component:()=>import('../views/seckill/seckill_settings'),
    meta:{
      title:'限时秒杀-秒杀设置'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/seckill.js